import {Component} from 'react';
import TimeSeriesChart from '../../shared-components/time_series_chart';
import buildUrl from '../../../objects/CommonUse/build_URL';
import Config from '../../../config';
import WaitTimeSpinner from '../../shared-components/wait_time_spinner';
import { setHeadersForFetch } from '../../../objects/CommonUse/set_headers_for_fetch';
import { rollForwardDate } from '../../game-views/objects/roll_forward_date_function';
import { rollBackwardDate } from '../../game-views/objects/roll_backward_date_function';
import DropDownOptionCard from '../../shared-components/drop_down_option_card';

class InvestmentPriceGraph extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleDateRangeChange.bind(this);
        this.state = {
            open: false, 
            rerender: false,
            selectedDateRange: 12, // default value, e.g., "last 12 months"
            investmentMonthlyLoaded: false,
            headers: setHeadersForFetch(),
            subProcess: "InvestmentPriceGraph",
            environment: Config.dataURL.currentEnv,
        };
        this.investmentMonthArr = [];
        this.investmentMonthlyPriceData = [];
        this.dateOptionsArr = [];
        this.dateRangeChange = false;
        this.determineDateRangeOptions();
    }

  determineDateRangeOptions(){
        this.dateOptionsArr = [];
        let value = 12;
        let selection = "last 12 months";
        this.addToDateOptionsArr(value, selection);
        let monthNbr = this.props.monthNbr - 24;
        let maxNbrMonths = 60;
        if (this.props.fromProcess && this.props.fromProcess === "admin"){
            maxNbrMonths = 9999
        }
        while (monthNbr >= 1 && value < maxNbrMonths){
            value = value + 12;
            const yearNbr = (value / 12).toFixed(0);
            selection = "last " + yearNbr + " years";
            this.addToDateOptionsArr(value, selection);
            monthNbr = monthNbr - 12;
        }  
    }
        
    addToDateOptionsArr(value, selection){
        const dateRangeObj = {value: value, selection: selection};
        this.dateOptionsArr.push(dateRangeObj);
    }

    render() {
        this.graphDisplay = this.investmentMonthArr.map((monthData, index) =>
            <TimeSeriesChart key={index} monthInfo={monthData}
                investType={this.investType}
                buyDates={this.props.buyDates}
                yearSpan={this.yearSpan}
                />
            );
        this.dateOptions = this.dateOptionsArr.map((optionsList,index) =>
                <DropDownOptionCard options={optionsList} key={index} />
            );
        
     return <>
         <span>
            {!this.state.investmentMonthlyLoaded   ?
                    <WaitTimeSpinner/>
            :
                <span>
                    
                    <h5 className="text-center mt-4">Price History for &nbsp;
                            {this.props.investmentName}</h5> 
                    <div className="text-right">
                        <label className="font-weight-bold mx-2" htmlFor="dateRange">Graph Values:&nbsp;</label>
                        <select 
                            value={this.state.selectedDateRange} // bind to selected value
                            onChange={(e) => this.handleDateRangeChange(e.target.value)}
                            className="btn btn-sm btn-outline-secondary dropdown-toggle" 
                            id="dateRange" >
                                {this.dateOptions}
                        </select>
                    </div> 
                    <div>
                            {this.graphDisplay}
                    </div>
                    
            
                </span>
            }
        </span>

</>
    }

componentDidMount(){
    this.firstMonthDate = this.props.firstMonthDate;
    this.startMonthNbr = this.props.monthNbr - 12;
    this.investType = "stock";
    this.investShortName = this.props.investShortName;
    this.loadInvestmentMonthly();
}
 

handleDateRangeChange(newMonthNbr){
    this.setState({ selectedDateRange: +newMonthNbr }); // store the selection
    
    this.newMonthNbr = newMonthNbr;
    this.startMonthNbr = this.props.monthNbr - +this.newMonthNbr;
    //  the firstMOnthDate is already 1 year ago.... so should subtract 1 year less than 'newMonthNbr'
    const monthDiff = this.newMonthNbr - 12;
  
    if (monthDiff === 0){
        this.firstMonthDate = this.props.firstMonthDate;
    }else{
        this.firstMonthDate = rollBackwardDate(this.props.firstMonthDate, monthDiff);
    }
    this.dateRangeChange = true;
    this.yearSpan = (+this.newMonthNbr / 12).toFixed(0);
    this.loadInvestmentMonthly(this.investShortName);
}
    
loadInvestmentMonthly(){
    this.setState({investmentMonthlyLoaded: false});
    this.investmentMonthlyPriceData = [];
    const funcName = "investmentMonthlySelect";
    this.gameInvestBehavior = "1";
    const urlParm = "?investShortName=" + this.investShortName + "&behavior=" + this.gameInvestBehavior  + 
        "&startMonthNbr=" + this.startMonthNbr +  "&endMonthNbr=" + this.props.monthNbr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
            {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.investmentMonthlyPriceData = output.body;
                    this.reformatMonthlyPriceData();                   
                }else{
                    const errorObj={function: funcName, subProcess: this.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: urlParm};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}

reformatMonthlyPriceData(){
    let monthPriceArr = [];
    let monthDate = "";
    this.investmentMonthArr = [];
    for (let i=0; i<this.investmentMonthlyPriceData.length; i++){
        if (i === 0){
            monthDate = this.firstMonthDate;
        }else{
            monthDate = rollForwardDate(this.firstMonthDate, i);
        }
        const monthPriceObj = {monthNbr: this.investmentMonthlyPriceData[i].monthNbr,
                monthDate: monthDate, unitPrice: this.investmentMonthlyPriceData[i].closingPrice};
        monthPriceArr.push(monthPriceObj);
    }
    const investmentMonthObj = {investShortName: this.investmentMonthlyPriceData[0].investShortName,
        monthPriceArr: monthPriceArr }
    this.investmentMonthArr.push(investmentMonthObj);
    this.setState({investmentMonthlyLoaded: true});
}


}

export default InvestmentPriceGraph;